module.exports = __webpack_public_path__ + "img/nf.nf96d57c5.svg";